<template>
  <f7-searchbar
      disable-button-text="Cancel"
      placeholder="Zoek op naam (min 3 karakters)"
      v-model:value="query"
      :clear-button="true"
  ></f7-searchbar>
  <f7-list class="search-list list-strong list-outline list-dividers" v-if="data.length === 0">
    <slot name="extra_items"></slot>
    <f7-list-item :title="noMatchesString"></f7-list-item>
  </f7-list>
  <f7-list class="search-list searchbar-found list-strong list-outline list-dividers" v-else>
    <slot name="extra_items"></slot>
    <slot></slot>
  </f7-list>
  <div class="m-3 mb-5">
    <div class="row">
      <div class="col">
        <f7-button large fill @click="loadPreviousPage" :disabled="page <= 1">
          <f7-icon f7="chevron_left" class="mr-2"></f7-icon> Vorige
        </f7-button>
      </div>
      <div class="col">
        <f7-button large fill @click="loadNextPage" :disabled="nextPageLink === null">
          Volgende <f7-icon f7="chevron_right" class="ml-2"></f7-icon>
        </f7-button>
      </div>
    </div>
  </div>
</template>

<script>

import ThrottlesRequests from "@/mixins/ThrottlesRequests.vue";

export default {
  components: {},

  props: {
    data: {required: true},
    searchOnLoad: {default: true},
    noMatchesString: {default: 'Geen matches'},
    subscriptionStatusFilter: {default: 1},
    subscriptionSort: {default: 'desc'},
  },

  mixins: [
    ThrottlesRequests,
  ],

  data: function () {
    return {
      query: '',
      page: 1,
      nextPageLink: null,
      data: [],
    };
  },

  computed: {
    //
  },

  created() {
    //
  },

  mounted() {
    if(this.searchOnLoad) {
      this.searchUsers();
    }
  },

  methods: {
    searchUsers() {
      this.$store.commit('app/show_loader');
      this.dispatchThrottled('api/getEndpoint', {
        endpoint: '/users/search',
        data: {
          page: this.page,
          query: this.query,
          subscriptionStatusFilter: this.subscriptionStatusFilter,
          subscriptionSort: this.subscriptionSort,
        }
      }).then(response => {
        this.$store.dispatch('app/scrollToTop');

        this.nextPageLink = response.data.links.next;
        this.$emit('updated', response.data.data);
        this.$emit('updatedMetaData', response.data.meta_data);
      })
      .finally(() => {
        this.$store.commit('app/hide_loader');
      })
    },
    loadNextPage() {
      this.page++;
      this.searchUsers();
    },
    loadPreviousPage() {
      this.page--;
      this.searchUsers();
    }
  },

  watch: {
    query(query) {
      if(query.length) {
        this.searchUsers();
      }
      else {
        this.data = [];
        this.searchUsers();
      }
    },
    loading(loading) {
      if(loading) {
        this.$store.commit('app/show_loader');
      }
      else {
        this.$store.commit('app/hide_loader');
      }
    },
    subscriptionSort() {
      this.searchUsers();
    },
  }
};
</script>
